import { OrganizationReportsCombo } from "go-report-combo/Organization";
import { apiReport } from "../../../../../../../../services/Api/Report/apiReport";

export const OrganizationReportsComboPage = () => {
	const { getComboReport } = apiReport;

	return <OrganizationReportsCombo getComboReport={getComboReport} />;
};
